<template>
<div>
            <div class="div-label"><label>上传文件之前请先下载<span style="font-weight: bold"  @click="exportFile">数据模板</span></label></div>
            <div><h3>如果对上传数据有任何不清楚请根据数据模板进行上传</h3></div>
            <div style="margin-top: 2%;">
                      <el-button
                        slot="extra"
                        type="primary"
                        @click="exportFile"
                        ><a-icon type="download" />下载数据模板</el-button>
            </div>

          <div style="margin-top: 2%;">
            <h2>导入说明</h2>
            <div>新增数据：在Excel内新增了数据信息，导入时则会将新增的部分作为全新的数据录入；</div>
            <div>更新数据：在Excel内修改了已有数据信息，导入后则会对已有数据的信息进行更新。</div>
            <div slot="tip" class="el-upload__tip">只能上传EXCEL文件，且文件大小不超过100MB</div>
          </div>

          <!--  action="http://192.168.100.190:8988/property/importExcelBigData" -->
          <!-- action="https://assert.hyhdit.com/apiYang/property/importExcelBigData" -->
          <div style="margin-top: 2%;">
          <el-upload
            class="upload-demo"
            action="https://assert.hyhdit.com/apiYang/property/importExcelBigData"
            :on-change="handleChange"
            :on-success="handleSuccess"
			:on-progress="handleProgress"
			:on-error="handleError"
            :headers="token"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          </div>





</div>
</template>

<script>
  import Cookies from "js-cookie";
  export default {
     name: 'Property_Insert_More',
     data () {
       return {
          token:{
            Authorization:Cookies.get("Authorization")
          },
          fileName:'数据模板',
           fileList: [{
                    name: '数据一.xlsx',
                  }, {
                    name: '数据二.xlsx',
                  }]
                };
     },
     created() {
        // 将token存入备用
        this.token.Authorization =Cookies.get("Authorization");
     },
     methods: {
		 
      GoTo(){
        console.log(this.$parent.$parent.$parent.$parent.$parent.$parent.addTab("手动添加","Property_Insert"))
      },

	  // 成功下载通知
      handleSuccess(res){
        if(res.code==200){
        	this.open2(res.message)
        	this.showData()
        }else{
        	this.open3(res.message)
        }
      },
	  // 成功下载通知
	  handleError(res){
		  this.$notify({
		    title: '上传失败',
				message: res.message,
		    type: 'warning',
		    duration: 3000
		  });
	  },
	  handleProgress() {
	  	this.$notify({
	  	  title: '上传中......',
	  	  message: '上传中，请稍等.....',
	  	  type: 'warning',
	  	  duration: 3000
	  	});
	  },
		open2(val) {
		        this.$notify({
		          title: '上传成功',
		          message: val,
		          type: 'success',
		          duration: 3000
		        });
		      },
		open3(val) {
		        this.$notify({
		          title: '上传失败',
		          message: val,
		          type: 'danger',
		          duration: 3000
		        });
		      },
	  
	  
 
	  // 文件上传，可支持多次上传显示
      handleChange(file, fileList) {
              this.fileList = fileList.slice(-3);
            },
				  // 模板下载功能在第九行和第三行，此处不能用axios使用fetch
      exportFile() {
          var authorization = Cookies.get("Authorization");
          fetch('https://assert.hyhdit.com/apiYang/property/downloadTemplate', {
              method: 'POST',
              headers:{
                'Content-Type': 'application/json',
                'Authorization': authorization
              },
          })
         .then(res => res.blob())
         .then(data => {
              const blobUrl = window.URL.createObjectURL(data);
              const a = document.createElement('a');
              a.download = this.fileName+'.xlsx';
              a.href = blobUrl;
              a.click();
          });
      },


     }
   }
</script>

<style>
  .div-label{
    margin-top: 2%;
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Insert_More.vue